module.exports = __webpack_public_path__ + "static/media/typed.js.6b58ab9e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/typed.js.gif
// module id = 512
// module chunks = 0